<template>
	<div class="about" id="about">
    <DirectionArrows :position="$props.position" :count="$props.count" :sidebar="$props.sidebar"/>
		<HelloWorld msg="A propos"/>
		<div class="about-container">

		</div>
	</div>
</template>
<script>
	// @ is an alias to /src
	import HelloWorld from '@/components/HelloWorld.vue'
	import DirectionArrows from '@/components/ArrowsDirection.vue'

	export default {
		name: 'About',
    props:['position','sidebar','count'],
		components: {
			HelloWorld,
      DirectionArrows
		},
		methods: {}
	}
</script>
<style>
	#about {
		height: 80%;
		order: 1;
    width: 40%;
    transition: .3s;
  }
    .about-container{
        width: 100%;
        display: flex;
        flex-direction: column;
    }
</style>
